/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpRightIcon24Regular = forwardRef('ArrowDCornerUpRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.869 1.631A.875.875 0 1 0 13.63 2.87l5.257 5.256H7A3.875 3.875 0 0 0 3.125 12v9a.875.875 0 0 0 1.75 0v-9c0-1.174.951-2.125 2.125-2.125h11.887l-5.256 5.256a.875.875 0 1 0 1.238 1.238l5.503-5.504a2.637 2.637 0 0 0 0-3.73L14.87 1.631Z" })));
});
